import { Navigate } from "react-router-dom";
import { useAccessControl } from "../hooks/useAccessControl";

interface Props {
    children: React.ReactNode;
}

/**
 * Route-level guard cho pages cần `hasAccess` (e.g. /classes, /my-registrations).
 * Nếu SV chưa được cấp slot đăng ký → redirect "/" (LandingPage sẽ render queue/waiting).
 * Combine với ProtectedRoute (đã handle login + periodClosed).
 *
 * <c>canPreview</c>: bật bởi <c>Registration:AllowPreviewBeforeOpen=true</c> để SV xem trước
 * danh sách lớp khi cổng chưa mở. Nút Đăng ký vẫn disabled (ClassesPage gate theo time window).
 */
export const RequireAccess = ({ children }: Props) => {
    const { hasAccess, canPreview } = useAccessControl();

    if (!hasAccess && !canPreview) {
        return <Navigate to="/" replace />;
    }
    return <>{children}</>;
};
